"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedLocalesContext = void 0;
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var react_redux_1 = require("react-redux");
var config_1 = require("../../config");
var en_json_1 = __importDefault(require("../../translations/en.json"));
var hu_json_1 = __importDefault(require("../../translations/hu.json"));
require("@formatjs/intl-displaynames/polyfill");
require("@formatjs/intl-displaynames/locale-data/en");
require("@formatjs/intl-displaynames/locale-data/hu");
require("@formatjs/intl-pluralrules/polyfill");
require("@formatjs/intl-pluralrules/locale-data/en");
require("@formatjs/intl-pluralrules/locale-data/hu");
var utils_1 = require("./utils");
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
var NAVIGATOR_LOCALES = navigator.languages || [navigator.language];
var WEB_FRAME_MESSAGES = {
    en: en_json_1.default,
    hu: hu_json_1.default,
};
var TIME_ZONE = (0, config_1.getConfig)().TIME_ZONE;
exports.SupportedLocalesContext = (0, react_1.createContext)([]);
var RawIntlProvider = function (props) {
    var supportedLocales = props.supportedLocales, preferredLocale = props.preferredLocale, messages = props.messages, children = props.children, keycloakLocale = props.keycloakLocale, rest = __rest(props, ["supportedLocales", "preferredLocale", "messages", "children", "keycloakLocale"]);
    var preferredLocales = [];
    if (keycloakLocale) {
        preferredLocales.push(keycloakLocale);
    }
    var storageLocale = (0, utils_1.getStorageLocale)();
    if (storageLocale !== null) {
        preferredLocales.push(storageLocale);
    }
    if (preferredLocale) {
        preferredLocales.push(preferredLocale);
    }
    preferredLocales.push.apply(preferredLocales, NAVIGATOR_LOCALES);
    var locale = determineBestFittingLocale(supportedLocales, preferredLocales);
    var mergedMessages = __assign(__assign({}, WEB_FRAME_MESSAGES[locale]), ((messages === null || messages === void 0 ? void 0 : messages[locale]) || {}));
    return (react_1.default.createElement(react_intl_1.IntlProvider, __assign({ locale: locale, messages: mergedMessages, timeZone: TIME_ZONE }, rest),
        react_1.default.createElement(exports.SupportedLocalesContext.Provider, { value: supportedLocales }, children)));
};
var IntlProvider = (0, react_redux_1.connect)(function (_a) {
    var _b;
    var preferredLocale = _a.preferredLocale, auth = _a.auth;
    return ({
        preferredLocale: preferredLocale,
        keycloakLocale: ((_b = auth.keycloak) === null || _b === void 0 ? void 0 : _b.tokenParsed)
            && auth.keycloak.tokenParsed.locale,
    });
})(RawIntlProvider);
exports.default = IntlProvider;
function determineBestFittingLocale(supportedLocales, preferredLocales) {
    for (var _i = 0, preferredLocales_1 = preferredLocales; _i < preferredLocales_1.length; _i++) {
        var locale = preferredLocales_1[_i];
        var short = locale.split('-')[0];
        if (supportedLocales.includes(short)) {
            return short;
        }
    }
    return supportedLocales[0];
}
